import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=2d17c382&scoped=true&"
import script from "./Transactions.vue?vue&type=script&lang=js&"
export * from "./Transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d17c382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d17c382')) {
      api.createRecord('2d17c382', component.options)
    } else {
      api.reload('2d17c382', component.options)
    }
    module.hot.accept("./Transactions.vue?vue&type=template&id=2d17c382&scoped=true&", function () {
      api.rerender('2d17c382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Account/Transactions.vue"
export default component.exports